export const DEFAULT_PAGE_SIZE = 10;

export const getTableColumns = (t: (key: string) => string) => [
  { key: 'account', name: t('partner.orders.publicLinksModal.account') },
  { key: 'statistics', name: t('partner.orders.publicLinksModal.statistics') },
  { key: 'income', name: t('partner.orders.publicLinksModal.income') },
  { key: 'status', name: t('partner.orders.publicLinksModal.status') },
];

export const getSourceLabels = (t: (key: string) => string) => ({
  reddit: 'Reddit',
  only_fans: 'OnlyFans',
  instagram: 'Instagram',
  tiktok: 'TikTok',
  google: 'Google',
  telegram: 'Telegram',
  twitter: 'Twitter',
  youtube: 'YouTube',
  another: t('partner.offers.otherSource'),
});

export const STATUS_COLORS = {
  in_progress: 'bg-success',
  waiting: 'bg-warning',
  canceled: 'bg-auth-strength-weak',
  completed: 'bg-partner',
};

export const getStatusLabels = (t: (key: string) => string) => ({
  in_progress: t('partner.orders.addPublicLinkModal.statusInProgress'),
  waiting: t('partner.orders.addPublicLinkModal.statusWaiting'),
  canceled: t('partner.orders.addPublicLinkModal.statusCanceled'),
  completed: t('partner.orders.addPublicLinkModal.statusCompleted'),
});
